import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Centre} from '../models/centre';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/region';

@Injectable()
export class RegionService {
  constructor(private http: HttpClient) {
  }

  getAllGouvernorat(): Observable<any> {
    const url = `${apiUrl}`+'/gouvernorat';
    return this.http.get<any>(url);
  }

  getAllDelegation(): Observable<any> {
      const url = `${apiUrl}`+'/delegations';
      return this.http.get<any>(url);
    }

    getAllImada(): Observable<any> {
        const url = `${apiUrl}`+'/imadas';
        return this.http.get<any>(url);
      }

   getDelegationByGouvernorat(gov): Observable<any> {
      const url = `${apiUrl}`+'/delgation/'+gov;
      return this.http.get<any>(url);
    }

     getImadaByDelegation(del): Observable<any> {
        const url = `${apiUrl}`+'/imada/'+del;
        return this.http.get<any>(url);
      }

}
